// eslint-disable-next-line no-shadow
export enum BaseImageLoadingType {
	LAZY = 'lazy',
	EAGER = 'eager',
	AUTO = 'auto',
}
